var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3103 2.44775H4.3103C3.2073 2.44775 2.3103 3.34176 2.3103 4.43976V16.4558C2.3103 17.5538 3.2073 18.4478 4.3103 18.4478H7.3103V22.4478L13.6613 18.4478H20.3103C21.4133 18.4478 22.3103 17.5538 22.3103 16.4558V4.43976C22.3087 3.91055 22.0972 3.40358 21.7223 3.03013C21.3473 2.65667 20.8395 2.44722 20.3103 2.44775ZM14.3103 13.4478H7.3103V11.4478H14.3103V13.4478ZM17.3103 9.44776H7.3103V7.44776H17.3103V9.44776Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgIcon);
export default __webpack_public_path__ + "static/media/msg-icon.083124f67f5eea332c872714b9150092.svg";
export { ForwardRef as ReactComponent };